import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
  TableHead,
  Pagination,
} from '@/components/ui/table'
import { useReactTable, getCoreRowModel } from '@tanstack/react-table'
import { flexRender } from '@tanstack/react-table'
import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'

export default function DataTable({
  isLoading,
  total,
  data,
  columns,
  page,
  setPage,
  pageSize,
  setPageSize,
  isPagination = true,
  rowSelection = {},
  setRowSelection = {},
  handleRowClick = () => {},
  ...props
}) {
  const totalColumns = columns.length
  const table = useReactTable({
    data,
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    state: {
      rowSelection,
    },
    onRowSelectionChange: setRowSelection,
    ...(props.getRowId ? { getRowId: props.getRowId } : {}),
  })

  return (
    <React.Fragment>
      <Table className="flex-1 table-auto overflow-auto">
        <TableHeader className="w-full">
          {table.getHeaderGroups().map((headerGroup) => {
            return (
              <TableRow key={headerGroup.id} className="w-full">
                {headerGroup.headers.map((header) => {
                  return (
                    <TableHead key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                    </TableHead>
                  )
                })}
              </TableRow>
            )
          })}
        </TableHeader>
        <TableBody className="w-full">
          {isLoading &&
            Array.from({ length: 10 }).map((_, index) => (
              <TableRow key={index} className="w-full">
                {Array.from({ length: 11 }).map((_, columnIndex) => (
                  <TableCell key={columnIndex}>
                    <Skeleton className="h-6 w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          {!isLoading && total > 0
            ? table.getRowModel().rows.map((row) => (
                <TableRow
                  key={row.id}
                  data-state={row.getIsSelected() && 'selected'}
                  className="cursor-pointer"
                  onClick={() => handleRowClick(row)}
                >
                  {row.getAllCells().map((cell) => {
                    return (
                      <TableCell key={cell.id}>
                        <div
                          className={`flex h-6 items-center ${cell.column.columnDef.className ? cell.column.columnDef.className : ''}`}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                        </div>
                      </TableCell>
                    )
                  })}
                </TableRow>
              ))
            : null}
          {!isLoading && total === 0 ? (
            <TableRow>
              <TableCell colSpan={totalColumns} className="h-6 text-center">
                Không có dữ liệu.
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
      {isPagination && (
        <div className="bottom-0">
          <Pagination
            totalRecords={total}
            page={page}
            pageSize={pageSize}
            setPage={setPage}
            setPageSize={setPageSize}
          />
        </div>
      )}
    </React.Fragment>
  )
}
